module.exports = __webpack_public_path__ + "static/logo_white-136f71a4a87bfaebce8e619227be7e25.png";